import { m as me, Y as pt, a4 as We, f as X, a5 as ze, a6 as Ke, a7 as Ye, a as ge, b as be, B as Ct, Z as Ue, t as R, g as H, h as w, q as kt, a8 as Xe, d as xt, u as Ge, c as he, k as it, l as mt, w as Se, F as et, x as Wt, K as Ze, j as G, z as rt, M as I, X as K, n as Je, a9 as Ee, aa as Qe, ab as tn, ac as zt, ad as en, ae as oe, C as ft, a2 as nn, U as ye, S as rn, v as Vt, i as on, D as sn } from "./7FZLUSKW.7Pws8uOI.js";
import * as Ft from "react";
import { createContext as gt, useRef as W, useState as Q, useMemo as Pe, useEffect as q, isValidElement as un, useCallback as At, useContext as Kt } from "react";
import { u as an } from "./index.DvbvgNu_.js";
import { flushSync as De, createPortal as se } from "react-dom";
import { jsx as x, jsxs as Ot, Fragment as Tt } from "react/jsx-runtime";
import { g as cn, i as ln, F as fn, c as Mt, d as ie, r as dn, e as pn, j as vn, k as dt, a as mn, l as gn } from "./ZHUQ44XA.CPgwIBVH.js";
import { u as bn } from "./2ATXICAB.fJmgtImF.js";
function ot(t, e) {
  const n = t.__unstableInternals;
  return me(n, "Invalid store"), n[e];
}
function _t(t, ...e) {
  let n = t, r = n, o = Symbol(), i = Ct;
  const s = /* @__PURE__ */ new Set(), u = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set(), d = /* @__PURE__ */ new Set(), S = /* @__PURE__ */ new Set(), y = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakMap(), T = (g) => (a.add(g), () => a.delete(g)), A = () => {
    const g = s.size, v = Symbol();
    s.add(v);
    const j = () => {
      s.delete(v), !s.size && i();
    };
    if (g) return j;
    const $ = We(n).map(
      (P) => X(
        ...e.map((O) => {
          var F;
          const k = (F = O == null ? void 0 : O.getState) == null ? void 0 : F.call(O);
          if (k && pt(k, P))
            return vt(O, [P], (Z) => {
              m(
                P,
                Z[P],
                // @ts-expect-error - Not public API. This is just to prevent
                // infinite loops.
                !0
              );
            });
        })
      )
    ), C = [];
    for (const P of a)
      C.push(P());
    const _ = e.map(xe);
    return i = X(...$, ...C, ..._), j;
  }, V = (g, v, j = d) => (j.add(v), f.set(v, g), () => {
    var $;
    ($ = y.get(v)) == null || $(), y.delete(v), f.delete(v), j.delete(v);
  }), L = (g, v) => V(g, v), N = (g, v) => (y.set(v, v(n, n)), V(g, v)), Y = (g, v) => (y.set(v, v(n, r)), V(g, v, S)), D = (g) => _t(ze(n, g), p), c = (g) => _t(Ke(n, g), p), b = () => n, m = (g, v, j = !1) => {
    var $;
    if (!pt(n, g)) return;
    const C = Ye(v, n[g]);
    if (C === n[g]) return;
    if (!j)
      for (const F of e)
        ($ = F == null ? void 0 : F.setState) == null || $.call(F, g, C);
    const _ = n;
    n = ge(be({}, n), { [g]: C });
    const P = Symbol();
    o = P, u.add(g);
    const O = (F, k, Z) => {
      var tt;
      const ut = f.get(F), Et = (at) => Z ? Z.has(at) : at === g;
      (!ut || ut.some(Et)) && ((tt = y.get(F)) == null || tt(), y.set(F, F(n, k)));
    };
    for (const F of d)
      O(F, _);
    queueMicrotask(() => {
      if (o !== P) return;
      const F = n;
      for (const k of S)
        O(k, r, u);
      r = F, u.clear();
    });
  }, p = {
    getState: b,
    setState: m,
    __unstableInternals: {
      setup: T,
      init: A,
      subscribe: L,
      sync: N,
      batch: Y,
      pick: D,
      omit: c
    }
  };
  return p;
}
function Nt(t, ...e) {
  if (t)
    return ot(t, "setup")(...e);
}
function xe(t, ...e) {
  if (t)
    return ot(t, "init")(...e);
}
function we(t, ...e) {
  if (t)
    return ot(t, "subscribe")(...e);
}
function vt(t, ...e) {
  if (t)
    return ot(t, "sync")(...e);
}
function hn(t, ...e) {
  if (t)
    return ot(t, "batch")(...e);
}
function Sn(t, ...e) {
  if (t)
    return ot(t, "omit")(...e);
}
function Pr(t, ...e) {
  if (t)
    return ot(t, "pick")(...e);
}
function En(...t) {
  const e = t.reduce((r, o) => {
    var i;
    const s = (i = o == null ? void 0 : o.getState) == null ? void 0 : i.call(o);
    return s ? Object.assign(r, s) : r;
  }, {});
  return _t(e, ...t);
}
function yn(t, e) {
  if (process.env.NODE_ENV === "production" || !e) return;
  const n = Object.entries(t).filter(([i, s]) => i.startsWith("default") && s !== void 0).map(([i]) => {
    var s;
    const u = i.replace("default", "");
    return `${((s = u[0]) == null ? void 0 : s.toLowerCase()) || ""}${u.slice(1)}`;
  });
  if (!n.length) return;
  const r = e.getState();
  if (n.filter(
    (i) => pt(r, i)
  ).length)
    throw new Error(
      `Passing a store prop in conjunction with a default state is not supported.

const store = useSelectStore();
<SelectProvider store={store} defaultValue="Apple" />
                ^             ^

Instead, pass the default state to the topmost store:

const store = useSelectStore({ defaultValue: "Apple" });
<SelectProvider store={store} />

See https://github.com/ariakit/ariakit/pull/2745 for more details.

If there's a particular need for this, please submit a feature request at https://github.com/ariakit/ariakit
`
    );
}
var { useSyncExternalStore: Pn } = an, Dn = () => () => {
};
function z(t, e = Ue) {
  const n = Ft.useCallback(
    (o) => t ? we(t, null, o) : Dn(),
    [t]
  ), r = () => {
    const o = typeof e == "string" ? e : null, i = typeof e == "function" ? e : null, s = t == null ? void 0 : t.getState();
    if (i) return i(s);
    if (s && o && pt(s, o))
      return s[o];
  };
  return Pn(n, r, r);
}
function It(t, e, n, r) {
  const o = pt(e, n) ? e[n] : void 0, i = r ? e[r] : void 0, s = Xe({ value: o, setValue: i });
  R(() => vt(t, [n], (u, a) => {
    const { value: d, setValue: S } = s.current;
    S && u[n] !== a[n] && u[n] !== d && S(u[n]);
  }), [t, n]), R(() => {
    if (o !== void 0)
      return t.setState(n, o), hn(t, [n], () => {
        o !== void 0 && t.setState(n, o);
      });
  });
}
function Ce(t, e) {
  const [n, r] = Ft.useState(() => t(e));
  R(() => xe(n), [n]);
  const o = Ft.useCallback(
    (u) => z(n, u),
    [n]
  ), i = Ft.useMemo(
    () => H(w({}, n), { useState: o }),
    [n, o]
  ), s = kt(() => {
    r((u) => t(w(w({}, e), u.getState())));
  });
  return [i, s];
}
function Fe(t = {}) {
  const e = En(
    t.store,
    Sn(t.disclosure, ["contentElement", "disclosureElement"])
  );
  yn(t, e);
  const n = e == null ? void 0 : e.getState(), r = xt(
    t.open,
    n == null ? void 0 : n.open,
    t.defaultOpen,
    !1
  ), o = xt(t.animated, n == null ? void 0 : n.animated, !1), i = {
    open: r,
    animated: o,
    animating: !!o && r,
    mounted: r,
    contentElement: xt(n == null ? void 0 : n.contentElement, null),
    disclosureElement: xt(n == null ? void 0 : n.disclosureElement, null)
  }, s = _t(i, e);
  return Nt(
    s,
    () => vt(s, ["animated", "animating"], (u) => {
      u.animated || s.setState("animating", !1);
    })
  ), Nt(
    s,
    () => we(s, ["open"], () => {
      s.getState().animated && s.setState("animating", !0);
    })
  ), Nt(
    s,
    () => vt(s, ["open", "animating"], (u) => {
      s.setState("mounted", u.open || u.animating);
    })
  ), ge(be({}, s), {
    disclosure: t.disclosure,
    setOpen: (u) => s.setState("open", u),
    show: () => s.setState("open", !0),
    hide: () => s.setState("open", !1),
    toggle: () => s.setState("open", (u) => !u),
    stopAnimation: () => s.setState("animating", !1),
    setContentElement: (u) => s.setState("contentElement", u),
    setDisclosureElement: (u) => s.setState("disclosureElement", u)
  });
}
function Oe(t, e, n) {
  return Ge(e, [n.store, n.disclosure]), It(t, n, "open", "setOpen"), It(t, n, "mounted", "setMounted"), It(t, n, "animated"), Object.assign(t, { disclosure: n.disclosure });
}
function xn(t = {}) {
  const [e, n] = Ce(Fe, t);
  return Oe(e, n, t);
}
function wn(t = {}) {
  return Fe(t);
}
function Cn(t, e, n) {
  return Oe(t, e, n);
}
function Fn(t = {}) {
  const [e, n] = Ce(wn, t);
  return Cn(e, n, t);
}
var bt = he();
bt.useContext;
bt.useScopedContext;
var Te = bt.useProviderContext, On = bt.ContextProvider, Tn = bt.ScopedContextProvider, ht = he(
  [On],
  [Tn]
), Dr = ht.useContext, xr = ht.useScopedContext, Yt = ht.useProviderContext, wr = ht.ContextProvider, Ae = ht.ScopedContextProvider, An = gt(void 0), _n = gt(void 0), Rn = "div";
function ue(t, e) {
  const n = setTimeout(e, t);
  return () => clearTimeout(n);
}
function Vn(t) {
  let e = requestAnimationFrame(() => {
    e = requestAnimationFrame(t);
  });
  return () => cancelAnimationFrame(e);
}
function ae(...t) {
  return t.join(", ").split(", ").reduce((e, n) => {
    const r = n.endsWith("ms") ? 1 : 1e3, o = Number.parseFloat(n || "0s") * r;
    return o > e ? o : e;
  }, 0);
}
function _e(t, e, n) {
  return !n && e !== !1 && (!t || !!e);
}
var Ut = it(function(e) {
  var n = e, { store: r, alwaysVisible: o } = n, i = mt(n, ["store", "alwaysVisible"]);
  const s = Te();
  r = r || s, me(
    r,
    process.env.NODE_ENV !== "production" && "DisclosureContent must receive a `store` prop or be wrapped in a DisclosureProvider component."
  );
  const u = W(null), a = Se(i.id), [d, S] = Q(null), y = r.useState("open"), f = r.useState("mounted"), T = r.useState("animated"), A = r.useState("contentElement"), V = z(r.disclosure, "contentElement");
  R(() => {
    u.current && (r == null || r.setContentElement(u.current));
  }, [r]), R(() => {
    let D;
    return r == null || r.setState("animated", (c) => (D = c, !0)), () => {
      D !== void 0 && (r == null || r.setState("animated", D));
    };
  }, [r]), R(() => {
    if (T) {
      if (!(A != null && A.isConnected)) {
        S(null);
        return;
      }
      return Vn(() => {
        S(y ? "enter" : f ? "leave" : null);
      });
    }
  }, [T, A, y, f]), R(() => {
    if (!r || !T || !d || !A) return;
    const D = () => r == null ? void 0 : r.setState("animating", !1), c = () => De(D);
    if (d === "leave" && y || d === "enter" && !y) return;
    if (typeof T == "number")
      return ue(T, c);
    const {
      transitionDuration: b,
      animationDuration: m,
      transitionDelay: p,
      animationDelay: g
    } = getComputedStyle(A), {
      transitionDuration: v = "0",
      animationDuration: j = "0",
      transitionDelay: $ = "0",
      animationDelay: C = "0"
    } = V ? getComputedStyle(V) : {}, _ = ae(
      p,
      g,
      $,
      C
    ), P = ae(
      b,
      m,
      v,
      j
    ), O = _ + P;
    if (!O) {
      d === "enter" && r.setState("animated", !1), D();
      return;
    }
    const F = 1e3 / 60, k = Math.max(O - F, 0);
    return ue(k, c);
  }, [r, T, A, V, y, d]), i = et(
    i,
    (D) => /* @__PURE__ */ x(Ae, { value: r, children: D }),
    [r]
  );
  const L = _e(f, i.hidden, o), N = i.style, Y = Pe(() => L ? H(w({}, N), { display: "none" }) : N, [L, N]);
  return i = H(w({
    id: a,
    "data-open": y || void 0,
    "data-enter": d === "enter" || void 0,
    "data-leave": d === "leave" || void 0,
    hidden: L
  }, i), {
    ref: Wt(a ? r.setContentElement : null, u, i.ref),
    style: Y
  }), Ze(i);
}), Mn = G(function(e) {
  const n = Ut(e);
  return rt(Rn, n);
});
G(function(e) {
  var n = e, {
    unmountOnHide: r
  } = n, o = mt(n, [
    "unmountOnHide"
  ]);
  const i = Te(), s = o.store || i;
  return z(
    s,
    (a) => !r || (a == null ? void 0 : a.mounted)
  ) === !1 ? null : /* @__PURE__ */ x(Mn, w({}, o));
});
function Re(t, ...e) {
  if (!t) return !1;
  const n = t.getAttribute("data-backdrop");
  return n == null ? !1 : n === "" || n === "true" || !e.length ? !0 : e.some((r) => n === r);
}
var Lt = /* @__PURE__ */ new WeakMap();
function St(t, e, n) {
  Lt.has(t) || Lt.set(t, /* @__PURE__ */ new Map());
  const r = Lt.get(t), o = r.get(e);
  if (!o)
    return r.set(e, n()), () => {
      var u;
      (u = r.get(e)) == null || u(), r.delete(e);
    };
  const i = n(), s = () => {
    i(), o(), r.delete(e);
  };
  return r.set(e, s), () => {
    r.get(e) === s && (i(), r.set(e, o));
  };
}
function Xt(t, e, n) {
  return St(t, e, () => {
    const o = t.getAttribute(e);
    return t.setAttribute(e, n), () => {
      o == null ? t.removeAttribute(e) : t.setAttribute(e, o);
    };
  });
}
function nt(t, e, n) {
  return St(t, e, () => {
    const o = e in t, i = t[e];
    return t[e] = n, () => {
      o ? t[e] = i : delete t[e];
    };
  });
}
function Bt(t, e) {
  return t ? St(t, "style", () => {
    const r = t.style.cssText;
    return Object.assign(t.style, e), () => {
      t.style.cssText = r;
    };
  }) : () => {
  };
}
function Nn(t, e, n) {
  return t ? St(t, e, () => {
    const o = t.style.getPropertyValue(e);
    return t.style.setProperty(e, n), () => {
      o ? t.style.setProperty(e, o) : t.style.removeProperty(e);
    };
  }) : () => {
  };
}
var In = ["SCRIPT", "STYLE"];
function qt(t) {
  return `__ariakit-dialog-snapshot-${t}`;
}
function Ln(t, e) {
  const n = I(e), r = qt(t);
  if (!n.body[r]) return !0;
  do {
    if (e === n.body) return !1;
    if (e[r]) return !0;
    if (!e.parentElement) return !1;
    e = e.parentElement;
  } while (!0);
}
function Hn(t, e, n) {
  return In.includes(e.tagName) || !Ln(t, e) ? !1 : !n.some(
    (r) => r && K(e, r)
  );
}
function Gt(t, e, n, r) {
  for (let o of e) {
    if (!(o != null && o.isConnected)) continue;
    const i = e.some((a) => !a || a === o ? !1 : a.contains(o)), s = I(o), u = o;
    for (; o.parentElement && o !== s.body; ) {
      if (r == null || r(o.parentElement, u), !i)
        for (const a of o.parentElement.children)
          Hn(t, a, e) && n(a, u);
      o = o.parentElement;
    }
  }
}
function $n(t, e) {
  const { body: n } = I(e[0]), r = [];
  return Gt(t, e, (i) => {
    r.push(nt(i, qt(t), !0));
  }), X(nt(n, qt(t), !0), () => {
    for (const i of r)
      i();
  });
}
function st(t = "", e = !1) {
  return `__ariakit-dialog-${e ? "ancestor" : "outside"}${t ? `-${t}` : ""}`;
}
function Bn(t, e = "") {
  return X(
    nt(t, st(), !0),
    nt(t, st(e), !0)
  );
}
function Ve(t, e = "") {
  return X(
    nt(t, st("", !0), !0),
    nt(t, st(e, !0), !0)
  );
}
function Zt(t, e) {
  const n = st(e, !0);
  if (t[n]) return !0;
  const r = st(e);
  do {
    if (t[r]) return !0;
    if (!t.parentElement) return !1;
    t = t.parentElement;
  } while (!0);
}
function ce(t, e) {
  const n = [], r = e.map((i) => i == null ? void 0 : i.id);
  return Gt(
    t,
    e,
    (i) => {
      Re(i, ...r) || n.unshift(Bn(i, t));
    },
    (i, s) => {
      s.hasAttribute("data-dialog") && s.id !== t || n.unshift(Ve(i, t));
    }
  ), () => {
    for (const i of n)
      i();
  };
}
var qn = "div", jn = [
  "a",
  "button",
  "details",
  "dialog",
  "div",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "header",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "section",
  "select",
  "span",
  "summary",
  "textarea",
  "ul",
  "svg"
];
it(
  function(e) {
    return e;
  }
);
var jt = G(
  // @ts-expect-error
  function(e) {
    return rt(qn, e);
  }
);
Object.assign(
  jt,
  jn.reduce((t, e) => (t[e] = G(function(r) {
    return rt(e, r);
  }), t), {})
);
function kn({
  store: t,
  backdrop: e,
  alwaysVisible: n,
  hidden: r
}) {
  const o = W(null), i = xn({ disclosure: t }), s = z(t, "contentElement");
  q(() => {
    const d = o.current, S = s;
    d && S && (d.style.zIndex = getComputedStyle(S).zIndex);
  }, [s]), R(() => {
    const d = s == null ? void 0 : s.id;
    if (!d) return;
    const S = o.current;
    if (S)
      return Ve(S, d);
  }, [s]);
  const u = Ut({
    ref: o,
    store: i,
    role: "presentation",
    "data-backdrop": (s == null ? void 0 : s.id) || "",
    alwaysVisible: n,
    hidden: r ?? void 0,
    style: {
      position: "fixed",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
  if (!e) return null;
  if (un(e))
    return /* @__PURE__ */ x(jt, H(w({}, u), { render: e }));
  const a = typeof e != "boolean" ? e : "div";
  return /* @__PURE__ */ x(jt, H(w({}, u), { render: /* @__PURE__ */ x(a, {}) }));
}
function Wn(t, ...e) {
  if (!t) return !1;
  const n = t.getAttribute("data-focus-trap");
  return n == null ? !1 : e.length ? n === "" ? !1 : e.some((r) => n === r) : !0;
}
function zn(t) {
  return Xt(t, "aria-hidden", "true");
}
function Me() {
  return "inert" in HTMLElement.prototype;
}
function Ne(t, e) {
  if (!("style" in t)) return Ct;
  if (Me())
    return nt(t, "inert", !0);
  const r = cn(t, !0).map((o) => {
    if (e != null && e.some((s) => s && K(s, o))) return Ct;
    const i = St(o, "focus", () => (o.focus = Ct, () => {
      delete o.focus;
    }));
    return X(Xt(o, "tabindex", "-1"), i);
  });
  return X(
    ...r,
    zn(t),
    Bt(t, {
      pointerEvents: "none",
      userSelect: "none",
      cursor: "default"
    })
  );
}
function Kn(t, e) {
  const n = [], r = e.map((i) => i == null ? void 0 : i.id);
  return Gt(
    t,
    e,
    (i) => {
      Re(i, ...r) || Wn(i, ...r) || n.unshift(Ne(i, e));
    },
    (i) => {
      i.hasAttribute("role") && (e.some((s) => s && K(s, i)) || n.unshift(Xt(i, "role", "none")));
    }
  ), () => {
    for (const i of n)
      i();
  };
}
function Yn({
  attribute: t,
  contentId: e,
  contentElement: n,
  enabled: r
}) {
  const [o, i] = Je(), s = At(() => {
    if (!r || !n) return !1;
    const { body: u } = I(n), a = u.getAttribute(t);
    return !a || a === e;
  }, [o, r, n, t, e]);
  return q(() => {
    if (!r || !e || !n) return;
    const { body: u } = I(n);
    if (s())
      return u.setAttribute(t, e), () => u.removeAttribute(t);
    const a = new MutationObserver(() => De(i));
    return a.observe(u, { attributeFilter: [t] }), () => a.disconnect();
  }, [o, r, e, n, s, t]), s;
}
function Un(t) {
  const e = t.getBoundingClientRect().left;
  return Math.round(e) + t.scrollLeft ? "paddingLeft" : "paddingRight";
}
function Xn(t, e, n) {
  const r = Yn({
    attribute: "data-dialog-prevent-body-scroll",
    contentElement: t,
    contentId: e,
    enabled: n
  });
  q(() => {
    if (!r() || !t) return;
    const o = I(t), i = Ee(t), { documentElement: s, body: u } = o, a = s.style.getPropertyValue("--scrollbar-width"), d = a ? Number.parseInt(a) : i.innerWidth - s.clientWidth, S = () => Nn(
      s,
      "--scrollbar-width",
      `${d}px`
    ), y = Un(s), f = () => Bt(u, {
      overflow: "hidden",
      [y]: `${d}px`
    }), T = () => {
      var V, L;
      const { scrollX: N, scrollY: Y, visualViewport: D } = i, c = (V = D == null ? void 0 : D.offsetLeft) != null ? V : 0, b = (L = D == null ? void 0 : D.offsetTop) != null ? L : 0, m = Bt(u, {
        position: "fixed",
        overflow: "hidden",
        top: `${-(Y - Math.floor(b))}px`,
        left: `${-(N - Math.floor(c))}px`,
        right: "0",
        [y]: `${d}px`
      });
      return () => {
        m(), process.env.NODE_ENV !== "test" && i.scrollTo({ left: N, top: Y, behavior: "instant" });
      };
    }, A = Qe() && !tn();
    return X(
      S(),
      A ? T() : f()
    );
  }, [r, t]);
}
var le = gt({});
function Gn(t) {
  const e = Kt(le), [n, r] = Q([]), o = At(
    (u) => {
      var a;
      return r((d) => [...d, u]), X((a = e.add) == null ? void 0 : a.call(e, u), () => {
        r((d) => d.filter((S) => S !== u));
      });
    },
    [e]
  );
  R(() => vt(t, ["open", "contentElement"], (u) => {
    var a;
    if (u.open && u.contentElement)
      return (a = e.add) == null ? void 0 : a.call(e, t);
  }), [t, e]);
  const i = Pe(() => ({ store: t, add: o }), [t, o]);
  return { wrapElement: At(
    (u) => /* @__PURE__ */ x(le.Provider, { value: i, children: u }),
    [i]
  ), nestedDialogs: n };
}
function Zn(t) {
  const e = W();
  return q(() => {
    if (!t) {
      e.current = null;
      return;
    }
    return zt("mousedown", (r) => {
      e.current = r.target;
    }, !0);
  }, [t]), e;
}
function Jn(t) {
  return t.tagName === "HTML" ? !0 : K(I(t).body, t);
}
function Qn(t, e) {
  if (!t) return !1;
  if (K(t, e)) return !0;
  const n = e.getAttribute("aria-activedescendant");
  if (n) {
    const r = I(t).getElementById(n);
    if (r)
      return K(t, r);
  }
  return !1;
}
function tr(t, e) {
  if (!("clientY" in t)) return !1;
  const n = e.getBoundingClientRect();
  return n.width === 0 || n.height === 0 ? !1 : n.top <= t.clientY && t.clientY <= n.top + n.height && n.left <= t.clientX && t.clientX <= n.left + n.width;
}
function Ht({
  store: t,
  type: e,
  listener: n,
  capture: r,
  domReady: o
}) {
  const i = kt(n), s = z(t, "open"), u = W(!1);
  R(() => {
    if (!s || !o) return;
    const { contentElement: a } = t.getState();
    if (!a) return;
    const d = () => {
      u.current = !0;
    };
    return a.addEventListener("focusin", d, !0), () => a.removeEventListener("focusin", d, !0);
  }, [t, s, o]), q(() => s ? zt(e, (d) => {
    const { contentElement: S, disclosureElement: y } = t.getState(), f = d.target;
    !S || !f || !Jn(f) || K(S, f) || Qn(y, f) || f.hasAttribute("data-focus-trap") || tr(d, S) || u.current && !Zt(f, S.id) || ln(f) || i(d);
  }, r) : void 0, [s, r]);
}
function $t(t, e) {
  return typeof t == "function" ? t(e) : !!t;
}
function er(t, e, n) {
  const r = z(t, "open"), o = Zn(r), i = { store: t, domReady: n, capture: !0 };
  Ht(H(w({}, i), {
    type: "click",
    listener: (s) => {
      const { contentElement: u } = t.getState(), a = o.current;
      a && en(a) && Zt(a, u == null ? void 0 : u.id) && $t(e, s) && t.hide();
    }
  })), Ht(H(w({}, i), {
    type: "focusin",
    listener: (s) => {
      const { contentElement: u } = t.getState();
      u && s.target !== I(u) && $t(e, s) && t.hide();
    }
  })), Ht(H(w({}, i), {
    type: "contextmenu",
    listener: (s) => {
      $t(e, s) && t.hide();
    }
  }));
}
function nr(t, e) {
  const r = I(t).createElement("button");
  return r.type = "button", r.tabIndex = -1, r.textContent = "Dismiss popup", Object.assign(r.style, {
    border: "0px",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0px",
    position: "absolute",
    whiteSpace: "nowrap",
    width: "1px"
  }), r.addEventListener("click", e), t.prepend(r), () => {
    r.removeEventListener("click", e), r.remove();
  };
}
var rr = "div", Ie = it(function(e) {
  var n = e, { autoFocusOnShow: r = !0 } = n, o = mt(n, ["autoFocusOnShow"]);
  return o = et(
    o,
    (i) => /* @__PURE__ */ x(fn.Provider, { value: r, children: i }),
    [r]
  ), o;
});
G(function(e) {
  const n = Ie(e);
  return rt(rr, n);
});
var fe = gt(0);
function or({ level: t, children: e }) {
  const n = Kt(fe), r = Math.max(
    Math.min(t || n + 1, 6),
    1
  );
  return /* @__PURE__ */ x(fe.Provider, { value: r, children: e });
}
var sr = "span", ir = it(
  function(e) {
    return e = H(w({
      "data-focus-trap": "",
      tabIndex: 0,
      "aria-hidden": !0
    }, e), {
      style: w({
        // Prevents unintended scroll jumps.
        position: "fixed",
        top: 0,
        left: 0
      }, e.style)
    }), e = bn(e), e;
  }
), wt = G(function(e) {
  const n = ir(e);
  return rt(sr, n);
}), de = gt(null), ur = "div";
function ar(t) {
  return I(t).body;
}
function cr(t, e) {
  return e ? typeof e == "function" ? e(t) : e : I(t).createElement("div");
}
function lr(t = "id") {
  return `${t ? `${t}-` : ""}${Math.random().toString(36).substr(2, 6)}`;
}
function J(t) {
  queueMicrotask(() => {
    t == null || t.focus();
  });
}
var Le = it(function(e) {
  var n = e, {
    preserveTabOrder: r,
    preserveTabOrderAnchor: o,
    portalElement: i,
    portalRef: s,
    portal: u = !0
  } = n, a = mt(n, [
    "preserveTabOrder",
    "preserveTabOrderAnchor",
    "portalElement",
    "portalRef",
    "portal"
  ]);
  const d = W(null), S = Wt(d, a.ref), y = Kt(de), [f, T] = Q(null), [A, V] = Q(
    null
  ), L = W(null), N = W(null), Y = W(null), D = W(null);
  return R(() => {
    const c = d.current;
    if (!c || !u) {
      T(null);
      return;
    }
    const b = cr(c, i);
    if (!b) {
      T(null);
      return;
    }
    const m = b.isConnected;
    if (m || (y || ar(c)).appendChild(b), b.id || (b.id = c.id ? `portal/${c.id}` : lr()), T(b), oe(s, b), !m)
      return () => {
        b.remove(), oe(s, null);
      };
  }, [u, i, y, s]), R(() => {
    if (!u || !r || !o) return;
    const b = I(o).createElement("span");
    return b.style.position = "fixed", o.insertAdjacentElement("afterend", b), V(b), () => {
      b.remove(), V(null);
    };
  }, [u, r, o]), q(() => {
    if (!f || !r) return;
    let c = 0;
    const b = (m) => {
      if (!ft(m)) return;
      const p = m.type === "focusin";
      if (cancelAnimationFrame(c), p)
        return dn(f);
      c = requestAnimationFrame(() => {
        pn(f, !0);
      });
    };
    return f.addEventListener("focusin", b, !0), f.addEventListener("focusout", b, !0), () => {
      cancelAnimationFrame(c), f.removeEventListener("focusin", b, !0), f.removeEventListener("focusout", b, !0);
    };
  }, [f, r]), a = et(
    a,
    (c) => {
      if (c = // While the portal node is not in the DOM, we need to pass the
      // current context to the portal context, otherwise it's going to
      // reset to the body element on nested portals.
      /* @__PURE__ */ x(de.Provider, { value: f || y, children: c }), !u) return c;
      if (!f)
        return /* @__PURE__ */ x(
          "span",
          {
            ref: S,
            id: a.id,
            style: { position: "fixed" },
            hidden: !0
          }
        );
      c = /* @__PURE__ */ Ot(Tt, { children: [
        r && f && /* @__PURE__ */ x(
          wt,
          {
            ref: N,
            "data-focus-trap": a.id,
            className: "__focus-trap-inner-before",
            onFocus: (m) => {
              ft(m, f) ? J(Mt()) : J(L.current);
            }
          }
        ),
        c,
        r && f && /* @__PURE__ */ x(
          wt,
          {
            ref: Y,
            "data-focus-trap": a.id,
            className: "__focus-trap-inner-after",
            onFocus: (m) => {
              ft(m, f) ? J(ie()) : J(D.current);
            }
          }
        )
      ] }), f && (c = se(c, f));
      let b = /* @__PURE__ */ Ot(Tt, { children: [
        r && f && /* @__PURE__ */ x(
          wt,
          {
            ref: L,
            "data-focus-trap": a.id,
            className: "__focus-trap-outer-before",
            onFocus: (m) => {
              !(m.relatedTarget === D.current) && ft(m, f) ? J(N.current) : J(ie());
            }
          }
        ),
        r && // We're using position: fixed here so that the browser doesn't
        // add margin to the element when setting gap on a parent element.
        /* @__PURE__ */ x("span", { "aria-owns": f == null ? void 0 : f.id, style: { position: "fixed" } }),
        r && f && /* @__PURE__ */ x(
          wt,
          {
            ref: D,
            "data-focus-trap": a.id,
            className: "__focus-trap-outer-after",
            onFocus: (m) => {
              if (ft(m, f))
                J(Y.current);
              else {
                const p = Mt();
                if (p === N.current) {
                  requestAnimationFrame(() => {
                    var g;
                    return (g = Mt()) == null ? void 0 : g.focus();
                  });
                  return;
                }
                J(p);
              }
            }
          }
        )
      ] });
      return A && r && (b = se(
        b,
        A
      )), /* @__PURE__ */ Ot(Tt, { children: [
        b,
        c
      ] });
    },
    [f, y, u, a.id, r, A]
  ), a = H(w({}, a), {
    ref: S
  }), a;
});
G(function(e) {
  const n = Le(e);
  return rt(ur, n);
});
var fr = "div", pe = on();
function dr(t) {
  const e = ye();
  return !e || t && K(t, e) ? !1 : !!dt(e);
}
function ve(t, e = !1) {
  if (!t) return null;
  const n = "current" in t ? t.current : t;
  return n ? e ? dt(n) ? n : null : n : null;
}
var pr = it(function(e) {
  var n = e, {
    store: r,
    open: o,
    onClose: i,
    focusable: s = !0,
    modal: u = !0,
    portal: a = !!u,
    backdrop: d = !!u,
    hideOnEscape: S = !0,
    hideOnInteractOutside: y = !0,
    getPersistentElements: f,
    preventBodyScroll: T = !!u,
    autoFocusOnShow: A = !0,
    autoFocusOnHide: V = !0,
    initialFocus: L,
    finalFocus: N,
    unmountOnHide: Y,
    unstable_treeSnapshotKey: D
  } = n, c = mt(n, [
    "store",
    "open",
    "onClose",
    "focusable",
    "modal",
    "portal",
    "backdrop",
    "hideOnEscape",
    "hideOnInteractOutside",
    "getPersistentElements",
    "preventBodyScroll",
    "autoFocusOnShow",
    "autoFocusOnHide",
    "initialFocus",
    "finalFocus",
    "unmountOnHide",
    "unstable_treeSnapshotKey"
  ]);
  const b = Yt(), m = W(null), p = Fn({
    store: r || b,
    open: o,
    setOpen(l) {
      if (l) return;
      const E = m.current;
      if (!E) return;
      const M = new Event("close", { bubbles: !1, cancelable: !0 });
      i && E.addEventListener("close", i, { once: !0 }), E.dispatchEvent(M), M.defaultPrevented && p.setOpen(!0);
    }
  }), { portalRef: g, domReady: v } = nn(a, c.portalRef), j = c.preserveTabOrder, $ = z(
    p,
    (l) => j && !u && l.mounted
  ), C = Se(c.id), _ = z(p, "open"), P = z(p, "mounted"), O = z(p, "contentElement"), F = _e(P, c.hidden, c.alwaysVisible);
  Xn(O, C, T && !F), er(p, y, v);
  const { wrapElement: k, nestedDialogs: Z } = Gn(p);
  c = et(c, k, [k]), R(() => {
    if (!_) return;
    const l = m.current, E = ye(l, !0);
    E && E.tagName !== "BODY" && (l && K(l, E) || p.setDisclosureElement(E));
  }, [p, _]), pe && q(() => {
    if (!P) return;
    const { disclosureElement: l } = p.getState();
    if (!l || !rn(l)) return;
    const E = () => {
      let M = !1;
      const h = () => {
        M = !0;
      }, B = { capture: !0, once: !0 };
      l.addEventListener("focusin", h, B), sn(l, "mouseup", () => {
        l.removeEventListener("focusin", h, !0), !M && gn(l);
      });
    };
    return l.addEventListener("mousedown", E), () => {
      l.removeEventListener("mousedown", E);
    };
  }, [p, P]), q(() => {
    if (!P || !v) return;
    const l = m.current;
    if (!l) return;
    const E = Ee(l), M = E.visualViewport || E, h = () => {
      var B, U;
      const lt = (U = (B = E.visualViewport) == null ? void 0 : B.height) != null ? U : E.innerHeight;
      l.style.setProperty("--dialog-viewport-height", `${lt}px`);
    };
    return h(), M.addEventListener("resize", h), () => {
      M.removeEventListener("resize", h);
    };
  }, [P, v]), q(() => {
    if (!u || !P || !v) return;
    const l = m.current;
    if (!(!l || l.querySelector("[data-dialog-dismiss]")))
      return nr(l, p.hide);
  }, [p, u, P, v]), R(() => {
    if (!Me() || _ || !P || !v) return;
    const l = m.current;
    if (l)
      return Ne(l);
  }, [_, P, v]);
  const tt = _ && v;
  R(() => {
    if (!C || !tt) return;
    const l = m.current;
    return $n(C, [l]);
  }, [C, tt, D]);
  const ut = kt(f);
  R(() => {
    if (!C || !tt) return;
    const { disclosureElement: l } = p.getState(), E = m.current, M = ut() || [], h = [
      E,
      ...M,
      ...Z.map((B) => B.getState().contentElement)
    ];
    return u ? X(
      ce(C, h),
      Kn(C, h)
    ) : ce(C, [l, ...h]);
  }, [
    C,
    p,
    tt,
    ut,
    Z,
    u,
    D
  ]);
  const Et = !!A, at = Vt(A), [He, $e] = Q(!1);
  q(() => {
    if (!_ || !Et || !v || !(O != null && O.isConnected)) return;
    const l = ve(L, !0) || // If no initial focus is specified, we try to focus the first element
    // with the autofocus attribute. If it's an Ariakit component, the
    // Focusable component will consume the autoFocus prop and add the
    // data-autofocus attribute to the element instead.
    O.querySelector(
      "[data-autofocus=true],[autofocus]"
    ) || // We have to fallback to the first focusable element otherwise portaled
    // dialogs with preserveTabOrder set to true will not receive focus
    // properly because the elements aren't tabbable until the dialog receives
    // focus.
    vn(O, !0, a && $) || // Finally, we fallback to the dialog element itself.
    O, E = dt(l);
    at(E ? l : null) && ($e(!0), queueMicrotask(() => {
      l.focus(), pe && l.scrollIntoView({ block: "nearest", inline: "nearest" });
    }));
  }, [
    _,
    Et,
    v,
    O,
    L,
    a,
    $,
    at
  ]);
  const yt = !!V, Jt = Vt(V), [Pt, Qt] = Q(!1);
  q(() => {
    if (_)
      return Qt(!0), () => Qt(!1);
  }, [_]);
  const ct = At(
    (l, E = !0) => {
      const { disclosureElement: M } = p.getState();
      if (dr(l)) return;
      let h = ve(N) || M;
      if (h != null && h.id) {
        const U = I(h), lt = `[aria-activedescendant="${h.id}"]`, Dt = U.querySelector(lt);
        Dt && (h = Dt);
      }
      if (h && !dt(h)) {
        const U = h.closest("[data-dialog]");
        if (U != null && U.id) {
          const lt = I(U), Dt = `[aria-controls~="${U.id}"]`, re = lt.querySelector(Dt);
          re && (h = re);
        }
      }
      const B = h && dt(h);
      if (!B && E) {
        requestAnimationFrame(() => ct(l, !1));
        return;
      }
      Jt(B ? h : null) && B && (h == null || h.focus());
    },
    [p, N, Jt]
  ), Rt = W(!1);
  R(() => {
    if (_ || !Pt || !yt) return;
    const l = m.current;
    Rt.current = !0, ct(l);
  }, [_, Pt, v, yt, ct]), q(() => {
    if (!Pt || !yt) return;
    const l = m.current;
    return () => {
      if (Rt.current) {
        Rt.current = !1;
        return;
      }
      ct(l);
    };
  }, [Pt, yt, ct]);
  const te = Vt(S);
  q(() => !v || !P ? void 0 : zt("keydown", (E) => {
    if (E.key !== "Escape" || E.defaultPrevented) return;
    const M = m.current;
    if (!M || Zt(M)) return;
    const h = E.target;
    if (!h) return;
    const { disclosureElement: B } = p.getState();
    !!(h.tagName === "BODY" || K(M, h) || !B || K(B, h)) && te(E) && p.hide();
  }, !0), [p, v, P, te]), c = et(
    c,
    (l) => /* @__PURE__ */ x(or, { level: u ? 1 : void 0, children: l }),
    [u]
  );
  const ee = c.hidden, ne = c.alwaysVisible;
  c = et(
    c,
    (l) => d ? /* @__PURE__ */ Ot(Tt, { children: [
      /* @__PURE__ */ x(
        kn,
        {
          store: p,
          backdrop: d,
          hidden: ee,
          alwaysVisible: ne
        }
      ),
      l
    ] }) : l,
    [p, d, ee, ne]
  );
  const [Be, qe] = Q(), [je, ke] = Q();
  return c = et(
    c,
    (l) => /* @__PURE__ */ x(Ae, { value: p, children: /* @__PURE__ */ x(An.Provider, { value: qe, children: /* @__PURE__ */ x(_n.Provider, { value: ke, children: l }) }) }),
    [p]
  ), c = H(w({
    id: C,
    "data-dialog": "",
    role: "dialog",
    tabIndex: s ? -1 : void 0,
    "aria-labelledby": Be,
    "aria-describedby": je
  }, c), {
    ref: Wt(m, c.ref)
  }), c = Ie(H(w({}, c), {
    autoFocusOnShow: He
  })), c = Ut(w({ store: p }, c)), c = mn(H(w({}, c), { focusable: s })), c = Le(H(w({ portal: a }, c), { portalRef: g, preserveTabOrder: $ })), c;
});
function vr(t, e = Yt) {
  return G(function(r) {
    const o = e(), i = r.store || o;
    return z(
      i,
      (u) => !r.unmountOnHide || (u == null ? void 0 : u.mounted) || !!r.open
    ) ? /* @__PURE__ */ x(t, w({}, r)) : null;
  });
}
var Cr = vr(
  G(function(e) {
    const n = pr(e);
    return rt(fr, n);
  }),
  Yt
);
export {
  wr as D,
  fe as H,
  vt as a,
  hn as b,
  _t as c,
  It as d,
  vr as e,
  z as f,
  Fn as g,
  xr as h,
  _e as i,
  An as j,
  Dr as k,
  Cr as l,
  En as m,
  xe as n,
  Sn as o,
  Pr as p,
  wn as q,
  Cn as r,
  Nt as s,
  yn as t,
  Ce as u,
  Ae as v,
  pr as w,
  Te as x,
  Yt as y
};
//# sourceMappingURL=YLXVVG22.DAM5w7Mj.js.map
